export const API_URL = process.env.REACT_APP_API_URL as string;
export const SHARE_URL = process.env.REACT_APP_SHARE_URL as string;

export const STRIPE_PUBLIC_KEY = process.env.REACT_APP_STRIPE_PUBLIC_KEY as string;

export const NFT_CONTRACT_ADDRESS = process.env.REACT_APP_NFT_CONTRACT_ADDRESS as string;

export const CHAIN_ID = Number(process.env.REACT_APP_CHAIN_ID);

export const PILLOW_PRICE_USD = Number(process.env.REACT_APP_PILLOW_PRICE_USD);
